// generated by genversion
export const version = '2.5.5';
//# sourceMappingURL=version.js.map